import grupoElite from 'assets/img/logos/28.png';
import grecia from 'assets/img/logos/LogoGrecia.png';
import shaddai from 'assets/img/logos/27.png';
///import amazon from 'assets/img/logos/paypal.png';

export default [
 {
  description:
   'Estamos muy contentos con el servicio de Fortis Control, una excelente inversión para la salud de nuestra mascota.',
  author: 'José Díaz',
  designation: 'Dueño de mascota',
  companyImage: grupoElite,
  size: 130
 },
 {
  description: 'Esto es simplemente lo mejor para el cuidado de mi compañero. Estoy muy agradecido por el servicio que prestan.',
  author: 'Giselle Santamaria',
  designation: 'Dueño de mascota',
  companyImage: grecia,
  size: 130
 },
 {
  description:
   'Es el mejor sistema de gestión para la salud de mi mascota, puedo estar tranquilo con su historial y seguimiento en Fortis Control.',
  author: 'Samyr Rodríguez',
  designation: 'Dueño de mascota',
  companyImage: shaddai,
  size: 100
 }
];
